import { OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import { NoResultsComponentLayout, SubtitleSection } from './no-results.style';

export const NoResultsComponent: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <NoResultsComponentLayout>
      <img src="/assets/images/magnifying-glass.svg" alt="No results" />
      <OwcTypography variant="title6">{t('components.no-results.title')}</OwcTypography>
      <SubtitleSection>
        <OwcTypography variant="body2">{t('components.no-results.subtitle')}</OwcTypography>
        <OwcTypography variant="body2">{t('components.no-results.subtitle2')}</OwcTypography>
      </SubtitleSection>
    </NoResultsComponentLayout>
  );
};
